import * as Sentry from '@sentry/react';

import {
  SET_SEGMENTS_ACCORDION_STATUS,
} from '../actions';

const initialState = [true];

const createProject = (state = initialState, action) => {
  Sentry.setTag('redux.action', action.type);

  switch (action.type) {
    case SET_SEGMENTS_ACCORDION_STATUS:
      return {
        ...state,
        segmentsAccordionStatus: action.payload,
      };

    default:
      return state;
  }
};

export default createProject;
